export default "https://cdn-static.gokick.com/assets/6ff5832d0d355fee068eb0a1603b37a2d61221c6/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";